import Mixpanel from './Mixpanel'

export default Mixpanel
